// NewPostNotifier.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { TranslationNamespace } from '../resource/translationNamespace.js';
import media from '../style/media.js';
import UserAvatar from '../container/UserAvatar.js';
import ArrowIcon from '../../img/ic-arrow-right-white.svg';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { color } from '../style/variables.js';

export const NewPostNotifier = ({
  feedNameWithQuery = null,
  userId = '',
  count = null,
  isShortVideo = false,
  isOnDesktop = false,
  expandBroadcastList = NULL_FUNCTION,
  messageId = '',
  t,
  fetchFeeds = NULL_FUNCTION,
}) => {
  useEffect(() => {
    if (count === null) {
      fetchFeeds({
        type: feedNameWithQuery,
      });
    }
  }, [feedNameWithQuery, count, fetchFeeds]);

  if (count === null || count === 0) {
    return null;
  }

  return (
    <StyledNewPostNotifier onClick={() => expandBroadcastList(messageId)}>
      <PostNotifierWrapper>
        <UserAvatar
          id={userId}
          size={isOnDesktop ? 36 : 22}
          imageStyle={{ border: '1px solid rgba(96, 196, 232, 0.81)' }}
        />
        <Text>
          {t(isShortVideo ? 'short_video_count' : 'broadcast_notification', {
            count,
            ns: TranslationNamespace.POST,
          })}
        </Text>
        <Icon src={ArrowIcon} alt="open" />
      </PostNotifierWrapper>
    </StyledNewPostNotifier>
  );
};

NewPostNotifier.propTypes = {
  feedNameWithQuery: PropTypes.string,
  messageId: PropTypes.string,
  userId: PropTypes.string,
  count: PropTypes.number,
  isShortVideo: PropTypes.bool,
  isOnDesktop: PropTypes.bool,
  fetchFeeds: PropTypes.func,
  expandBroadcastList: PropTypes.func,
  t: PropTypes.func.isRequired,
};

const StyledNewPostNotifier = styled.button`
  display: block;
  outline: none;
  border: none;
  background-color: transparent;
  padding: 0;
`;

const PostNotifierWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${color.sky};
  font-size: 16px;
  line-height: 1;
  overflow: hidden;
  height: 36px;
  opacity: 0.8;
  border-radius: 18px;
  ${media.mobile`
    font-size: 12px;
    height: 24px;
    opacity: 1;
    border-radius: 12px;
  `}
`;

const Text = styled.span`
  margin-left: 6px;
  color: ${color.white};
`;

const Icon = styled.img`
  margin-right: 4px;
  width: 20px;
  height: 20px;
  transform: rotate(-90deg);
`;

export default withTranslation()(NewPostNotifier);
